import { render, staticRenderFns } from "./AltCoinStats.vue?vue&type=template&id=ad093a16&scoped=true&"
import script from "./AltCoinStats.vue?vue&type=script&lang=js&"
export * from "./AltCoinStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad093a16",
  null
  
)

export default component.exports